import clsx from 'clsx';
import { type LinkProps, Link as ReactRouterDomLink } from 'react-router-dom';
import css from './Link.module.scss';

export function Link(props: LinkProps) {
  const { className, ...restProps } = props;

  return <ReactRouterDomLink {...restProps} className={clsx(css.link, className)} />;
}
